/** Published team reports can seed a new report; only the owner's report is revised in place. */
export function reportForEditing(report, actorId) {
  return report.created_by === actorId
    ? report
    : { ...report, report_id: null, status: 'draft' };
}
